'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('app-switch', {
      url: '/app-switch',
      template: '<app-switch></app-switch>'
    });
}



// WEBPACK FOOTER //
// ./client/app/app-switch/app-switch.routes.js